module.exports = __webpack_public_path__ + "img/loading.f799d081.gif";